
export class MatriculaGestaoModel {
  id?: number;
  candidatoId?: number;
  processoId?: number;
  candidatoNome?: string;
  candidatoCpf?: string;
  candidatoFiliacaoPai?: string;
  candidatoFiliacaoMae?: string;
  candidatoRG?: string;
  candidatoRGExpedidoEm?: any;
  candidatoRGExpedidoPor?: string;
  candidatoEstadoCivil?: string;
  candidatoProfissao?: string;
  candidatoTelefone?: string;
  candidatoEmail?: string;
  candidatoDataAniversario?: string;
  candidatoEndereco?: string;
  candidatoEnderecoNumero?: string;
  candidatoComplemento?: string;
  candidatoBairro?: string;
  candidatoCidade?: string;
  candidatoCEP?: string;
  candidatoNaturalidade?: string;
  candidatoImg_face?: string;
  cfcId?: number;
  cfcNome?: string;
  cfcCnpj?: string;
  numero?: string;
  observacao?: string;
  status?: string;
  justificativaCancelamento?: string;
  ativo?: boolean;
  usuarioCadastro?: string;
  dataCadastro?: any;
  usuarioAlteracao?: string;
  dataAlteracao?: any;
  processo?: Processo;
  candidato?: Candidato;
  dataAssinaturaContrato?: string;
  numeroNotaFiscal?: number;
  codigoVerificador?: number;
  dataEmissaoNotaFiscal?: any;

  constructor(options: MatriculaGestaoModel = {}) {
    this.id = options.id || null;
    this.candidatoId = options.candidatoId || null;
    this.processoId = options.processoId || null;
    this.candidatoNome = options.candidatoNome || null;
    this.candidatoCpf = options.candidatoCpf || null;
    this.candidatoFiliacaoPai = options.candidatoFiliacaoPai || null;
    this.candidatoFiliacaoMae = options.candidatoFiliacaoMae || null;
    this.candidatoRG = options.candidatoRG || null;
    this.candidatoRGExpedidoEm = options.candidatoRGExpedidoEm || null;
    this.candidatoRGExpedidoPor = options.candidatoRGExpedidoPor || null;
    this.candidatoEstadoCivil = options.candidatoEstadoCivil || null;
    this.candidatoProfissao = options.candidatoProfissao || null;
    this.candidatoTelefone = options.candidatoTelefone || null;
    this.candidatoEmail = options.candidatoEmail || null;
    this.candidatoDataAniversario = options.candidatoDataAniversario || null;
    this.candidatoEndereco = options.candidatoEndereco || null;
    this.candidatoEnderecoNumero = options.candidatoEnderecoNumero || null;
    this.candidatoComplemento = options.candidatoComplemento || null;
    this.candidatoBairro = options.candidatoBairro || null;
    this.candidatoCidade = options.candidatoCidade || null;
    this.candidatoCEP = options.candidatoCEP || null;
    this.candidatoNaturalidade = options.candidatoNaturalidade || null;
    this.candidatoImg_face = options.candidatoImg_face || null;
    this.cfcId = options.cfcId || null;
    this.cfcNome = options.cfcNome || null;
    this.cfcCnpj = options.cfcCnpj || null;
    this.numero = options.numero || null;
    this.observacao = options.observacao || null;
    this.status = options.status || null;
    this.justificativaCancelamento = options.justificativaCancelamento || null;
    this.ativo = options.ativo || null;
    this.usuarioCadastro = options.usuarioCadastro || null;
    this.dataCadastro = options.dataCadastro || null;
    this.usuarioAlteracao = options.usuarioAlteracao || null;
    this.dataAlteracao = options.dataAlteracao || null;
    this.processo = options.processo || null;
    this.candidato = options.candidato || null;
    this.dataAssinaturaContrato = options.dataAssinaturaContrato || null;
    this.numeroNotaFiscal = options.numeroNotaFiscal || null;
    this.codigoVerificador = options.codigoVerificador || null;
    this.dataEmissaoNotaFiscal = options.dataEmissaoNotaFiscal || null;
  }
}

class Processo {
  id?: number;
  candidatoId?: number;
  renach?: string;
  situacao?: string;
  servicosId?: number;
  categoriaCnhId?: number;
  dataAberturaRenach?: any;
  dataVencimentoRenach?: any;
  usuarioCadastro?: string;
  dataCadastro?: any;
  observacao?: string;
  candidatoNome?: string;
  ativo?: boolean;
  servico?: Servico;
  categoriaCnh?: CategoriaCnh;

  constructor(options: Processo = {}) {
    this.id = options.id || null;
    this.candidatoId = options.candidatoId || null;
    this.renach = options.renach || null;
    this.situacao = options.situacao || null;
    this.servicosId = options.servicosId || null;
    this.categoriaCnhId = options.categoriaCnhId || null;
    this.dataAberturaRenach = options.dataAberturaRenach || null;
    this.dataVencimentoRenach = options.dataVencimentoRenach || null;
    this.usuarioCadastro = options.usuarioCadastro || null;
    this.dataCadastro = options.dataCadastro || null;
    this.observacao = options.observacao || null;
    this.candidatoNome = options.candidatoNome || null;
    this.ativo = options.ativo || null;
    this.servico = options.servico || new Servico();
    this.categoriaCnh = options.categoriaCnh || new CategoriaCnh();
  }
}

class Servico {
  id?: number;
  nome?: string;
  ativo?: boolean;
  codigoExterno?: string;
  requerRenach?: boolean;
  usuarioCadastro?: string;
  dataCadastro?: any;
  usuarioAlteracao?: string;
  dataAlteracao?: any;

  constructor(options: Servico = {}) {
    this.id = options.id || null;
    this.nome = options.nome || null;
    this.ativo = options.ativo || null;
    this.codigoExterno = options.codigoExterno || null;
    this.requerRenach = options.requerRenach || null;
    this.usuarioCadastro = options.usuarioCadastro || null;
    this.dataCadastro = options.dataCadastro || null;
    this.usuarioAlteracao = options.usuarioAlteracao || null;
    this.dataAlteracao = options.dataAlteracao || null;
  }
}

class CategoriaCnh {
  id?: number;
  categoria?: string;
  ativo?: boolean;
  usuarioAlteracao?: string;
  dataAlteracao?: any;
  usuarioCadastro?: string;
  dataCadastro?: any;
  constructor(options: CategoriaCnh = {}) {
    this.id = options.id || null;
    this.categoria = options.categoria || null;
    this.ativo = options.ativo || null;
    this.usuarioAlteracao = options.usuarioAlteracao || null;
    this.dataAlteracao = options.dataAlteracao || null;
    this.usuarioCadastro = options.usuarioCadastro || null;
    this.dataCadastro = options.dataCadastro || null;
  }
}
interface Candidato {
  id: number;
  nome: string;
  dataAniversario: string;
  cpf: string;
  filiacaoPai: string;
  filiacaoMae: string;
  rg: string;
  rgExpedidoEm: any;
  rgExpedidoPor: string;
  estadoCivil: string;
  profissao: string;
  email: string;
  telefone: string;
  endereco: string;
  enderecoNumero: string;
  complemento: string;
  bairro: string;
  cidade: string;
  cep: string;
  naturalidade: string;
  img_face: string
}
export class MatriculaRequest {
  cnpj?: string;
  cpf?: string;
  filiacaoPai?: string;
  filiacaoMae?: string;
  rg?: string;
  rgExpedidoEm?: any;
  rgExpedidoPor?: string;
  estadoCivil?: string;
  profissao?: string;
  email?: string;
  dataAniversario?: any;
  nomeCandidato?: string;
  telefone?: string;
  observacao?: string;
  endereco?: string;
  enderecoNumero?: string;
  complemento?: string;
  bairro?: string;
  cidade?: string;
  cep?: string;
  naturalidade?: string;
  img_face?: string;
  renach?: string;
  situacao?: string;
  servicosId?: number;
  categoriaCnhId?: number;
  observacaoProcesso?: string;
  dataAberturaRenach?: any;
  dataVencimentoRenach?: any;
  numeroNotaFiscal?: number;
  codigoVerificador?: number;
  dataEmissaoNotaFiscal?: any;
  id?: number;
  dataAssinaturaContrato?: string;

  constructor(
    options: MatriculaRequest = {}
  ) {
    this.cnpj = options.cnpj || null;
    this.cpf = options.cpf || null;
    this.filiacaoPai = options.filiacaoPai || null;
    this.filiacaoMae = options.filiacaoMae || null;
    this.rg = options.rg || null;
    this.rgExpedidoEm = options.rgExpedidoEm || null;
    this.rgExpedidoPor = options.rgExpedidoPor || null;
    this.estadoCivil = options.estadoCivil || null;
    this.profissao = options.profissao || null;
    this.email = options.email || null;
    this.dataAniversario = options.dataAniversario || null;
    this.nomeCandidato = options.nomeCandidato || null;
    this.telefone = options.telefone || null;
    this.observacao = options.observacao || null;
    this.endereco = options.endereco || null;
    this.enderecoNumero = options.enderecoNumero || null;
    this.complemento = options.complemento || null;
    this.bairro = options.bairro || null;
    this.cidade = options.cidade || null;
    this.cep = options.cep || null;
    this.naturalidade = options.naturalidade || null;
    this.img_face = options.img_face || null;
    this.renach = options.renach || null;
    this.situacao = options.situacao || null;
    this.servicosId = options.servicosId || null;
    this.categoriaCnhId = options.categoriaCnhId || null;
    this.observacaoProcesso = options.observacaoProcesso || null;
    this.dataAberturaRenach = options.dataAberturaRenach || null;
    this.dataVencimentoRenach = options.dataVencimentoRenach || null;
    this.numeroNotaFiscal = options.numeroNotaFiscal || null;
    this.codigoVerificador = options.codigoVerificador || null;
    this.dataEmissaoNotaFiscal = options.dataEmissaoNotaFiscal || null;
    this.id = options.id || null;
    this.dataAssinaturaContrato = options.dataAssinaturaContrato || null;
  }
}

export class MatriculaUpdateRequestModel {
  id?: number;
  candidatoId?: number;
  processoId?: number;
  candidatoNome?: string;
  candidatoCpf?: string;
  candidatoFiliacaoPai?: string;
  candidatoFiliacaoMae?: string;
  candidatoRG?: string;
  candidatoRGExpedidoEm?: any;
  candidatoRGExpedidoPor?: string;
  candidatoEstadoCivil?: string;
  candidatoProfissao?: string;
  candidatoTelefone?: string;
  candidatoEmail?: string;
  candidatoDataAniversario?: string;
  candidatoEndereco?: string;
  candidatoEnderecoNumero?: string;
  candidatoComplemento?: string;
  candidatoBairro?: string;
  candidatoCidade?: string;
  candidatoCEP?: string;
  candidatoNaturalidade?: string;
  candidatoImg_face?: string;
  cfcId?: number;
  cfcNome?: string;
  cfcCnpj?: string;
  numero?: string;
  observacao?: string;
  status?: string;
  justificativaCancelamento?: string;
  numeroNotaFiscal?: number;
  codigoVerificador?: number;
  dataEmissaoNotaFiscal?: any;
  dataAssinaturaContrato?: string;

  constructor(options: MatriculaUpdateRequestModel = {}) {
    this.id = options.id || null;
    this.candidatoId = options.candidatoId || null;
    this.processoId = options.processoId || null;
    this.candidatoNome = options.candidatoNome || null;
    this.candidatoCpf = options.candidatoCpf || null;
    this.candidatoFiliacaoPai = options.candidatoFiliacaoPai || null;
    this.candidatoFiliacaoMae = options.candidatoFiliacaoMae || null;
    this.candidatoRG = options.candidatoRG || null;
    this.candidatoRGExpedidoEm = options.candidatoRGExpedidoEm || null;
    this.candidatoRGExpedidoPor = options.candidatoRGExpedidoPor || null;
    this.candidatoEstadoCivil = options.candidatoEstadoCivil || null;
    this.candidatoProfissao = options.candidatoProfissao || null;
    this.candidatoTelefone = options.candidatoTelefone || null;
    this.candidatoEmail = options.candidatoEmail || null;
    this.candidatoDataAniversario = options.candidatoDataAniversario || null;
    this.candidatoEndereco = options.candidatoEndereco || null;
    this.candidatoEnderecoNumero = options.candidatoEnderecoNumero || null;
    this.candidatoComplemento = options.candidatoComplemento || null;
    this.candidatoBairro = options.candidatoBairro || null;
    this.candidatoCidade = options.candidatoCidade || null;
    this.candidatoCEP = options.candidatoCEP || null;
    this.candidatoNaturalidade = options.candidatoNaturalidade || null;
    this.candidatoImg_face = options.candidatoImg_face || null;
    this.cfcId = options.cfcId || null;
    this.cfcNome = options.cfcNome || null;
    this.cfcCnpj = options.cfcCnpj || null;options.numero || null;
    this.observacao = options.observacao || null;
    this.status = options.status || null;
    this.justificativaCancelamento = options.justificativaCancelamento || null;
    this.numeroNotaFiscal = options.numeroNotaFiscal || null;
    this.codigoVerificador = options.codigoVerificador || null;
    this.dataEmissaoNotaFiscal = options.dataEmissaoNotaFiscal || null;
    this.dataAssinaturaContrato = options.dataAssinaturaContrato || null;
  }
}
